<div [ngStyle]="spinnerSizeStyle" class="spinner">
  <div class="spinner-css">
  </div>
</div>
